import React from 'react';
import { Navbar } from '../../Shared/components/Navbar';
import { LoadingSpinner } from '../../Shared/components/LoadingSpinner';
import { useTier } from '../../../hooks/useTier';
import PricingPage from './PricingPage';

const PricingPageRoute: React.FC = () => {
  const { billingActions, isLoading, error } = useTier();

  return (
    <Navbar>
      {isLoading ? (
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div className="max-w-4xl mx-auto px-4 py-12 text-center">
          <p className="text-red-600">{error}</p>
        </div>
      ) : (
        <PricingPage
          billingActions={
            billingActions ?? {
              can_upgrade: false,
              can_cancel: false,
              can_resume: false,
              show_payment_warning: false,
              show_trial_warning: false,
              show_upgrade_prompt: false,
              upgrade_tiers: [],
            }
          }
        />
      )}
    </Navbar>
  );
};

export default PricingPageRoute;
